import { randInt } from '../utils/fractionMath';

const NICE_PAIRS = [
  [1, 2], [1, 3], [1, 4], [1, 5],
  [2, 3], [3, 4], [1, 6], [2, 5],
  [3, 5], [4, 5], [1, 8], [3, 8],
  [5, 8], [1, 10], [3, 10], [4, 10], [7, 10],
];

export function generateTopic6Questions(count = 10) {
  const questions = [];
  for (let i = 0; i < count; i++) {
    const [num, den] = NICE_PAIRS[randInt(0, NICE_PAIRS.length - 1)];
    // x must be divisible by den/gcd so that num/den * x is a whole number
    // simplest: let x = den * k, then result = num * k
    const k = randInt(2, 12);
    const x = den * k;
    const result = num * k;

    questions.push({
      id: `t6_${i}`,
      topicId: 6,
      type: 'find_x',
      data: { num, den, result },
      correctAnswer: x,
    });
  }
  return questions;
}
